module.exports = __webpack_public_path__ + "img/selected2-min.bbe0c647.png";